/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Max_Duration_LabelInputs */



/**
* | output |
* | --- |
* | "Maximum Event Duration (sec)" |
*
* @param {Edit_Event_Group_Max_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_max_duration_label = /** @type {((inputs?: Edit_Event_Group_Max_Duration_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Max_Duration_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Durée maximale de l'événement (sec)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximale Ereignisdauer (Sek.)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Durata massima dell'evento (sec)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Максимальная продолжительность события (сек)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Duración máxima del evento (seg.)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件最大持续时间（秒）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最大イベント継続時間（秒）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अधिकतम घटना अवधि (सेकंड)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Duração máxima do evento (seg)")
	return /** @type {LocalizedString} */ ("Maximum Event Duration (sec)")
});